import { Helmet } from 'react-helmet';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, HelpInfo, Typography } from 'components';
import ClockIcon from 'assets/icons/clock.svg?react';
import CardWithIcon from 'components/CardWithIcon/CardWithIcon';
import { useApplicationQuery } from 'hooks/webapi';
import useNavigateByApplication from 'pages/Waiting/useNavigateByApplication';
import { useClientApplicationCheckStatusQuery } from 'hooks/webapi/client/useClientApplicationCheckStatusQuery';
import styles from './ManualReview.module.scss';

const ManualReview = memo(function PSD2VerifiedMemo() {
  const { t } = useTranslation(['manual_review', 'help_info']);
  const { navigateNext } = useNavigateByApplication();
  const [isPending, setPending] = useState(false);
  const [isPolling, setIsPolling] = useState(true);
  const [isApplicationResolved, setIsApplicationResolved] = useState(false);
  const { data: checkStatusData } = useClientApplicationCheckStatusQuery(
    isPolling,
    5000,
  );
  const { data: applicationData } = useApplicationQuery(
    checkStatusData?.completed,
  );

  useEffect(() => {
    if (checkStatusData?.completed) {
      setIsPolling(false);

      if (
        applicationData?.status === 'OPEN' &&
        applicationData?.resolution !== 'MANUAL'
      ) {
        setIsApplicationResolved(true);
      }
    }
  }, [checkStatusData?.completed]);

  const handleClick = async () => {
    setPending(true);
    if (applicationData) {
      navigateNext(applicationData);
    }
  };

  return (
    <>
      <Helmet>
        <title>
          {' '}
          {t(isApplicationResolved ? 'html_title_resolved' : 'html_title')}
        </title>
      </Helmet>

      <CardWithIcon
        icon={<ClockIcon />}
        heading={
          <Typography
            className={styles.header}
            dataTest="manual-review-header"
            kind="h1"
            size="l"
          >
            {t(isApplicationResolved ? 'heading_resolved' : 'heading')}
          </Typography>
        }
      >
        {isApplicationResolved ? (
          <div className={styles['box-wrapper']}>
            <Button
              className={styles.button}
              pending={isPending}
              onClick={handleClick}
              dataTest="psd2-verified"
            >
              {t('navigate')}
            </Button>
          </div>
        ) : (
          <Typography className={styles.margin}>
            <span> {t('description')}</span>
          </Typography>
        )}
      </CardWithIcon>
      <HelpInfo title={t('help_info:title')} text={t('help_info:text')} />
    </>
  );
});

export default ManualReview;
